module.exports = __webpack_public_path__ + "img/steering-wheel.a445e90b.svg";